var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoice-page" }, [
    _vm.view === "list" || _vm.view === "reports"
      ? _c(
          "div",
          { staticClass: "invoice-filter-wrap" },
          [
            _c(
              "portal-filter-bar",
              { attrs: { label: _vm.$t("global.filter") } },
              [
                _vm.view === "list"
                  ? _c("portal-search-field", {
                      attrs: {
                        label: _vm.$t("global.filter"),
                        placeholder: _vm.$t("global.filter"),
                        "clear-label": _vm.$t("global.clear")
                      },
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    })
                  : _vm._e(),
                _c("portal-select-field", {
                  attrs: {
                    label: _vm.$t("global.date"),
                    options: _vm.dateOptions
                  },
                  model: {
                    value: _vm.dateFilter,
                    callback: function($$v) {
                      _vm.dateFilter = $$v
                    },
                    expression: "dateFilter"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "invoice-content show-scrollbar" },
      [
        _c("invoice-table", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view === 'list'"
            }
          ],
          ref: "InvoiceTable",
          attrs: { invoices: _vm.dateFilteredInvoices, filter: _vm.filter },
          on: { refresh: _vm.getInvoices }
        }),
        _vm.view === "reports" &&
        _vm.$store.getters.getFeatures.summaryFinancialsEnabled
          ? _c("invoice-charts", {
              ref: "InvoiceChart",
              attrs: {
                invoices: _vm.dateFilteredInvoices,
                projects: _vm.projects,
                "deposit-account": _vm.depositAccount
              }
            })
          : _vm._e(),
        _vm.view === "plans"
          ? _c("payment-plan-list", {
              attrs: {
                plans: _vm.paymentPlans,
                loading: _vm.paymentPlansLoading,
                "load-error": _vm.paymentPlansLoadError,
                "highlighted-plan-id": _vm.plan
              },
              on: { refresh: _vm.getPaymentPlans }
            })
          : _vm._e(),
        _c("payment-methods", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "accounts",
              expression: "view === 'accounts'"
            }
          ],
          attrs: { "ach-enabled": _vm.achEnabled }
        }),
        _vm.view === "subscriptions" ? _c("subscription-list") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }